import { WarningOutlined } from '@ant-design/icons';
import { useMemo } from 'react';
import styled from 'styled-components';

import { CenterFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { CHART_GRAPH } from '@/entities/chart/model/constants';
import { COMBO_CHART_ERROR_MESSAGES } from '@/features/(charts)/chart-renderer/model/error-messages';
import useColor from '@/hooks/domain/useColor';

type Props = {
  state: ChartState;
};

const ChartComboValidateDisplay = (props: Props) => {
  const color = useColor();

  const validationResult = useMemo(() => {
    // COMBO_CHART가 아닌 경우 검증 불필요
    if (props.state.graph !== CHART_GRAPH.COMBO_CHART) {
      return { isValid: true, message: '' };
    }

    // Secondary measure가 없는 경우
    if (!props.state.series?.[0]?.measure) {
      return {
        isValid: false,
        message: COMBO_CHART_ERROR_MESSAGES.SECONDARY_MEASURE_MISSING,
      };
    }

    return { isValid: true, message: '' };
  }, [props.state]);

  if (validationResult.isValid) return null;

  return (
    <Style g={10}>
      <WarningOutlined style={{ color: color.destructive, fontSize: 16 }} />
      <Typo type="label2" color="gray700">
        {validationResult.message}
      </Typo>
    </Style>
  );
};

const Style = styled(CenterFlex)`
  background-color: ${({ theme }) => theme.colors.error_bg};
  border: 1px solid ${({ theme }) => theme.colors.destructive};
  border-radius: 6px;
  padding: 8px 12px;
  margin-top: 8px;
`;

export default ChartComboValidateDisplay;
